import { Decorators, EditorUtils, EntityDialog, EntityGrid, FormKeyAttribute, IEditDialog, ItemNameAttribute, PropertyGrid, PropertyGridMode, PropertyGridOptions, SubDialogHelper, TabsExtensions, TemplatedDialog, ToolButton, ValidationHelper, Widget } from "@serenity-is/corelib";
import { confirmDialog, DeleteResponse, endsWith, Exception, format, getAttributes, getForm, getInstanceType, isEmptyOrNull, isMobileView, localText, LT, notifySuccess, RetrieveRequest, RetrieveResponse, Router, SaveRequest, SaveResponse, serviceCall, ServiceOptions, tryGetText, UndeleteResponse, validateOptions, validatorAbortHandler } from "@serenity-is/corelib/q";

/** Auto save types */
export enum AutoSaveOption {
    /** Never auto save */
    Never = 0,
    /** Automatically save pending changes without asking */
    Auto = 1,
    /** Ask for confirmation from user to save pending changes */
    Confirm = 2
}

@Decorators.registerClass('Serenity.EntityGridDialog', [IEditDialog])
export class EntityGridDialog<TItem, TOptions> extends EntityGrid<TItem, TOptions> {

    protected tabs: JQuery;
    protected validator: JQueryValidation.Validator;
    declare idPrefix: string;
    protected dialogPane: JQuery;
    protected entity: TItem;
    protected entityId: any;
    protected propertyGrid: PropertyGrid;

    protected isDialogOpen: boolean;
    protected saveAndCloseButton: JQuery;
    protected applyChangesButton: JQuery;
    protected deleteButton: JQuery;
    protected undeleteButton: JQuery;
    protected cloneButton: JQuery;

    protected localizationGrid: PropertyGrid;
    protected localizationButton: JQuery;
    protected localizationPendingValue: any;
    protected localizationLastValue: any;
    protected loadedState: string;
    protected triedAutoSaveForCurrentEntity: boolean;

    constructor(container: JQuery, opt?: TOptions) {
        super(container, opt);

        this.element.on('ondatachange.' + this.uniqueName, () => {
            this.subDialogDataChange();
        });

        this.element.on('handleroute.' + this.uniqueName, (e, arg) => {
            if (arg.handled)
                return;

            if (!arg.route && this.isDialogOpen) {
                this.dialogClose();
            }
        });

        $(window).on('resize.' + this.uniqueName, () => {
            this.arrange();
        });
    }

    protected createSlickGrid() {
        var slickGrid = super.createSlickGrid();

        this.idPrefix = this.uniqueName + '_DLG_';

        this.element.addClass('s-GridWithDialog');

        this.dialogPane = $(`<div id="${this.uniqueName}_DLG" class="s-GridDialogPane flex-layout"></div>`)
            .appendTo(this.slickContainer);

        var widgetMarkup = this.getTemplate().replace(new RegExp('~_', 'g'), this.idPrefix);
        this.dialogPane.html(widgetMarkup);

        this.initValidator();
        this.initTabs();
        this.initPropertyGrid();
        this.initLocalizationGrid();
        return slickGrid;
    }

    public destroy(): void {

        $(window).off('resize.' + this.uniqueName);

        if (this.propertyGrid) {
            this.propertyGrid.destroy();
            this.propertyGrid = null;
        }

        if (this.localizationGrid) {
            this.localizationGrid.destroy();
            this.localizationGrid = null;
        }
        this.undeleteButton = null;
        this.applyChangesButton = null;
        this.deleteButton = null;
        this.saveAndCloseButton = null;
        this.tabs && (this.tabs as any).tabs('destroy');
        this.tabs = null;
        this.validator && this.byId('Form').remove();
        this.validator = null;
        super.destroy();
    }

    protected getItemCssClass(item: TItem, index: number) {
        var klass = super.getItemCssClass(item, index);

        if (this.isDialogOpen && this.entityId == item[this.getIdProperty()]) {
            return (klass || "") + " editing-item";
        }

        return klass;
    }

    getSaveState() {
        try {
            return $.toJSON(this.getSaveEntity());
        }
        catch (e) {
            return null;
        }
    }

    protected hasPendingChanges() {
        return this.getSaveState() != this.loadedState;
    }

    protected autoSaveOnSwitch(): AutoSaveOption {
        return AutoSaveOption.Never;
    }

    protected autoSaveOnClose(): AutoSaveOption {
        return AutoSaveOption.Never;
    }

    protected checkPendingChangesOnSwitch(entityOrId: any, proceed: () => void) {
        if (this.isDialogOpen &&
            (typeof entityOrId == "number" || typeof entityOrId == "string")) {

            if (entityOrId == this.entityId)
                return;

            if (this.autoSaveOnSwitch() && this.hasPendingChanges()) {

                if (this.autoSaveOnSwitch() == AutoSaveOption.Confirm || this.triedAutoSaveForCurrentEntity) {
                    confirmDialog(localText("Site.Dialogs.PendingChangesConfirmation"),
                        () => {
                            this.save(response => {
                                proceed();
                            });
                        },
                        {
                            onNo: () => {
                                this.loadResponse({});
                                proceed();
                            }
                        });
                }
                else {
                    this.triedAutoSaveForCurrentEntity = true;
                    this.save(response => {
                        proceed();
                    });
                }

                return;
            }
        }

        proceed();
    }

    protected editItem(entityOrId: any) {
        this.checkPendingChangesOnSwitch(entityOrId, () => {
            super.editItem(entityOrId);
        });
    }

    protected createEntityDialog(itemType: string, callback?: (dlg: Widget<any>) => void): Widget<any> {
        if (itemType == this.getItemType()) {
            callback && callback(this);
            return this;
        }

        return super.createEntityDialog(itemType, callback);
    }

    protected layout() {
        super.layout();
    }

    protected byId(id: string): JQuery {
        return $('#' + this.idPrefix + id);
    }

    protected getDefaultTemplateName(): string {
        return TemplatedDialog.prototype['getDefaultTemplateName'].call(this);
    }

    protected getTemplateName(): string {
        return TemplatedDialog.prototype['getTemplateName'].call(this);
    }

    protected getFallbackTemplate(): string {
        return `<div class="s-DialogContent">
<div class="s-Form">
    <form id="~_Form" action="">
        <div class="fieldset ui-widget ui-widget-content ui-corner-all">
            <div id="~_PropertyGrid"></div>
            <div class="clear"></div>
        </div>
    </form> 
</div>
</div>`;
    }

    protected getTemplate(): string {
        return TemplatedDialog.prototype['getTemplate'].call(this);
    }

    protected getValidatorOptions(): JQueryValidation.ValidationOptions {
        return {};
    }

    protected initValidator(): void {
        var form = this.byId('Form');
        if (form.length > 0) {
            var valOptions = this.getValidatorOptions();
            this.validator = form.validate(validateOptions(valOptions));
        }
    }

    protected resetValidation() {
        this.validator && (this.validator as any).resetAll();
    }

    protected validateForm() {
        return this.validator == null || !!this.validator.form();
    }

    public dialogOpen(): void {
        if (!this.isDialogOpen) {
            this.element.toggleClass("dialog-open", true);
            this.isDialogOpen = true;
            this.updateInterface();
            this.layout();
            this.onDialogOpen();

            Router.dialog(this.element, this.dialogPane, () => this.getEditHash());
            this.dialogPane.triggerHandler('panelopen');
        }
    }

    protected getEditHash() {
        if (this.entityId)
            return 'edit/' + this.entityId.toString();
        else
            return 'new';
    }

    protected onDialogOpen(): void {
        if (!isMobileView())
            $(':input', this.dialogPane).not('button').eq(0).focus();

        this.arrange();
        this.tabs && (this.tabs as any).tabs('option', 'active', 0);
    }

    public arrange(): void {
        if (window.innerWidth < 768) {
            this.dialogPane.children('.panel-titlebar')
                .prependTo(this.element);
        }
        else {
            this.element.children('.panel-titlebar')
                .prependTo(this.dialogPane);
        }

        this.dialogPane.find('.require-layout').filter(':visible').each(function (i, e) {
            $(e).triggerHandler('layout');
        });
    }

    protected onDialogClose() {
        $(document).trigger('click');

        if (($ as any).qtip) {
            $(document.body).children('.qtip').each(function (index, el) {
                ($(el) as any).qtip('hide');
            });
        }
    }

    protected getDialogTitle() {
        return "";
    }

    public dialogClose(): void {
        if (this.isDialogOpen) {
            this.triedAutoSaveForCurrentEntity = false;
            this.element.toggleClass("dialog-open", false);
            this.isDialogOpen = false;
            this.updateInterface();
            this.layout();
            this.onDialogClose();
            this.dialogPane.triggerHandler('panelclose');
        }
    }

    public get dialogTitle(): string {
        return this.element.data('dialogtitle');
    }

    public set dialogTitle(value: string) {
        var oldTitle = this.dialogTitle;
        this.element.data('dialogtitle', value);
        if (oldTitle != this.dialogTitle) {
            this.setupDialogTitle();
            this.arrange();
        }
    }

    protected setupDialogTitle(): void {
        var value = this.dialogTitle ?? this.getDialogTitle();
        var pt = this.dialogPane.children('.panel-titlebar')
            .add(this.element.children('.panel-titlebar'));
        if (isEmptyOrNull(value)) {
            pt.remove();
        }
        else {
            if (!pt.length) {
                pt = $("<div class='panel-titlebar'><div class='panel-titlebar-text'></div></div>")
                    .prependTo(this.dialogPane);
            }
            pt.children('.panel-titlebar-text').text(value);
            if (!pt.children('.panel-titlebar-close').length) {
                $('<button class="panel-titlebar-close">&nbsp;</button>')
                    .prependTo(pt)
                    .click(e => {
                        if (this.autoSaveOnClose() && this.hasPendingChanges()) {
                            e.preventDefault();

                            if (this.autoSaveOnClose() == AutoSaveOption.Confirm || this.triedAutoSaveForCurrentEntity) {
                                confirmDialog(localText("Site.Dialogs.PendingChangesConfirmation"),
                                    () => this.saveAndCloseButton.click(),
                                    {
                                        onNo: () => {
                                            this.dialogClose();
                                        }
                                    });
                            }
                            else {
                                this.triedAutoSaveForCurrentEntity = true;
                                this.saveAndCloseButton.click();
                            }
                        }
                        else
                            this.dialogClose();
                    });
            }
        }
    }

    protected initTabs(): void {
        var tabsDiv = this.byId('Tabs');
        if (tabsDiv.length === 0) {
            return;
        }
        this.tabs = (tabsDiv as any).tabs({});
        this.tabs.bind('tabsactivate', () => this.arrange());
    }

    protected get_entity(): TItem {
        return this.entity;
    }

    protected set_entity(entity: any): void {
        this.entity = entity || new Object();
    }

    protected get_entityId(): any {
        return this.entityId;
    }

    protected set_entityId(value: any) {
        this.entityId = value;
    }

    protected getEntityNameFieldValue(): any {
        return (this.get_entity()[this.getNameProperty()] ?? '').toString();
    }

    protected getEntityTitle(): string {
        if (!this.isEditMode()) {
            return format(localText('Controls.EntityDialog.NewRecordTitle'), this.getEntitySingular());
        }
        else {
            var title = this.getEntityNameFieldValue() ?? '';
            return format(localText('Controls.EntityDialog.EditRecordTitle'),
                this.getEntitySingular(), (isEmptyOrNull(title) ? '' : (' (' + title + ')')));
        }
    }

    protected updateTitle(): void {
        this.dialogTitle = this.getEntityTitle();
    }

    protected isCloneMode(): boolean {
        return false;
    }

    protected isEditMode(): boolean {
        return this.get_entityId() != null && !this.isCloneMode();
    }

    protected isDeleted(): boolean {
        return EntityDialog.prototype["isDeleted"].apply(this, arguments);
    }

    protected isNew(): boolean {
        return this.get_entityId() == null;
    }

    protected isNewOrDeleted(): boolean {
        return this.isNew() || this.isDeleted();
    }

    protected getDeleteOptions(callback: (response: DeleteResponse) => void): ServiceOptions<DeleteResponse> {
        return {};
    }

    protected deleteHandler(options: ServiceOptions<DeleteResponse>, callback: (response: DeleteResponse) => void): void {
        serviceCall(options);
    }

    protected doDelete(callback: (response: DeleteResponse) => void): void {
        return EntityDialog.prototype["doDelete"].apply(this, arguments);
    }

    protected onDeleteSuccess(response: DeleteResponse): void {
        return EntityDialog.prototype["onDeleteSuccess"].apply(this, arguments);
    }

    protected attrs<TAttr>(attrType: { new(...args: any[]): TAttr }): TAttr[] {
        return getAttributes(getInstanceType(this), attrType, true);
    }

    protected getEntityType(): string {

        var name = super.getEntityType();
        if (endsWith(name, 'Grid')) {
            this['entityType'] = name = name.substring(0, name.length - 4);
        }

        return name;
    }

    private formKey: string;

    protected getFormKey(): string {
        if (this.formKey != null)
            return this.formKey;

        var attributes = this.attrs(FormKeyAttribute);

        if (attributes.length >= 1)
            return (this.formKey = attributes[0].value);

        return (this.formKey = this.getEntityType());
    }

    private entitySingular: string;

    protected getEntitySingular(): string {
        if (this.entitySingular != null)
            return this.entitySingular;

        var attributes = this.attrs(ItemNameAttribute);

        if (attributes.length >= 1) {
            this.entitySingular = attributes[0].value;
            this.entitySingular = LT.getDefault(this.entitySingular, this.entitySingular);
        }
        else {
            var es = tryGetText(this.getLocalTextDbPrefix() + 'EntitySingular');
            if (es == null)
                es = this.getEntityType();
            this.entitySingular = es;
        }

        return this.entitySingular;
    }

    protected getNameProperty(): string {
        return EntityDialog.prototype["getNameProperty"].apply(this, arguments);
    }

    protected getIsDeletedProperty(): string {
        return EntityDialog.prototype["getIsDeletedProperty"].apply(this, arguments);
    }

    load(entityOrId: any, done: () => void, fail?: (ex: Exception) => void): void {
        return EntityDialog.prototype.load.call(this, entityOrId, done, fail);
    }

    loadNewAndOpenDialog(): void {
        this.loadResponse({});
        this.dialogOpen();
    }

    loadEntityAndOpenDialog(entity: TItem, asPanel?: boolean): void {
        this.loadResponse({ Entity: entity });
        this.dialogOpen();
    }

    protected loadResponse(data: any): void {
        var oldEntityId = this.entityId;
        data = data || {};
        this.onLoadingData(data);
        var entity = data.Entity || new Object();
        this.beforeLoadEntity(entity);
        this.loadEntity(entity);
        this.set_entity(entity);
        this.afterLoadEntity();
        if (this.isDialogOpen && oldEntityId != this.entityId)
            Router.replaceLast(this.getEditHash(), true);

        if (this.autoSaveOnClose() ||
            this.autoSaveOnSwitch()) {
            this.triedAutoSaveForCurrentEntity = false;
            this.loadedState = this.getSaveState();
        }
    }

    protected loadEntity(entity: TItem): void {
        var idField = this.getIdProperty();

        if (idField != null)
            this.set_entityId(entity[idField]);

        this.set_entity(entity);

        if (this.propertyGrid != null) {
            this.propertyGrid.set_mode((this.isEditMode() ?
                PropertyGridMode.update : PropertyGridMode.insert));
            this.propertyGrid.load(entity);
        }
    }

    protected beforeLoadEntity(entity: TItem): void {
        this.localizationPendingValue = null;
        this.localizationLastValue = null;
    }

    protected afterLoadEntity(): void {
        this.updateInterface();
        this.updateTitle();
        this.slickGrid.invalidate();
    }

    public loadByIdAndOpenDialog(entityId: any) {
        this.loadById(entityId,
            response => window.setTimeout(() => this.dialogOpen(), 0),
            () => {
                if (!this.element.is(':visible')) {
                    this.element.remove();
                }
            });
    }

    protected onLoadingData(data: RetrieveResponse<TItem>): void {
    }

    protected getLoadByIdOptions(id: any, callback: (response: RetrieveResponse<TItem>) => void): ServiceOptions<RetrieveResponse<TItem>> {
        return {};
    }

    protected getLoadByIdRequest(id: any): RetrieveRequest {
        var request: RetrieveRequest = {};
        request.EntityId = id;
        return request;
    }

    protected reloadById(): void {
        this.loadById(this.get_entityId());
    }

    loadById(id: any, callback?: (response: RetrieveResponse<TItem>) => void, fail?: () => void): void {
        return EntityDialog.prototype["loadById"].apply(this, arguments);
    }

    protected loadByIdHandler(options: ServiceOptions<RetrieveResponse<TItem>>, callback: (response: RetrieveResponse<TItem>) => void, fail: () => void): void {
        return EntityDialog.prototype["loadByIdHandler"].apply(this, arguments);
    }

    protected initLocalizationGrid(): void {
        return EntityDialog.prototype["initLocalizationGrid"].apply(this, arguments);
    }

    protected initLocalizationGridCommon(pgOptions: PropertyGridOptions): void {
        return EntityDialog.prototype["initLocalizationGridCommon"].apply(this, arguments);
    }

    protected isLocalizationMode(): boolean {
        return this.localizationButton != null && this.localizationButton.hasClass('pressed');
    }

    protected isLocalizationModeAndChanged(): boolean {
        return EntityDialog.prototype["isLocalizationModeAndChanged"].apply(this, arguments);
    }

    protected localizationButtonClick(): void {
        return EntityDialog.prototype["localizationButtonClick"].apply(this, arguments);
    }

    protected getLanguages(): any[] {
        return EntityDialog.prototype["getLanguages"].apply(this, arguments);
    }

    protected loadLocalization(): void {
        EntityDialog.prototype["loadLocalization"].apply(this, arguments);
    }

    protected setLocalizationGridCurrentValues(): void {
        EntityDialog.prototype["setLocalizationGridCurrentValues"].apply(this, arguments);
    }

    protected getLocalizationGridValue(): any {
        return EntityDialog.prototype["getLocalizationGridValue"].apply(this, arguments);
    }

    protected getPendingLocalizations(): any {
        return EntityDialog.prototype["getPendingLocalizations"].apply(this, arguments);
    }

    protected initPropertyGrid(): void {
        var pgDiv = this.byId('PropertyGrid');
        if (pgDiv.length <= 0) {
            return;
        }
        var pgOptions = this.getPropertyGridOptions();
        this.propertyGrid = (new PropertyGrid(pgDiv, pgOptions)).init(null);
        if (this.element.closest('.ui-dialog').hasClass('s-Flexify')) {
            this.propertyGrid.element.children('.categories').flexHeightOnly(1);
        }
    }

    protected getFormPropertyItems() {
        var formKey = this.getFormKey();
        return getForm(formKey);
    }

    protected getPropertyGridOptions(): PropertyGridOptions {
        return {
            idPrefix: this.idPrefix,
            items: this.getFormPropertyItems(),
            mode: PropertyGridMode.insert,
            localTextPrefix: 'Forms.' + this.getFormKey() + '.',
            useCategories: true
        };
    }

    protected validateBeforeSave(): boolean {
        return true;
    }

    protected getSaveOptions(callback: (response: SaveResponse) => void): ServiceOptions<SaveResponse> {

        var opt: ServiceOptions<SaveResponse> = {};

        opt.service = this.getService() + '/' + (this.isEditMode() ? 'Update' : 'Create'),

            opt.onSuccess = response => {
                this.triedAutoSaveForCurrentEntity = false;
                this.onSaveSuccess(response);

                callback && callback(response);

                var typ = (this.isEditMode() ? 'update' : 'create');

                var ent = opt.request == null ? null : opt.request.Entity;
                var eid: any = this.isEditMode() ? this.get_entityId() :
                    (response == null ? null : response.EntityId);

                var dci = {
                    type: typ,
                    entity: ent,
                    entityId: eid
                };

                this.element.triggerHandler('ondatachange', [dci]);
            };

        opt.onCleanup = () => {
            this.validator && validatorAbortHandler(this.validator);
        };

        opt.request = this.getSaveRequest();

        return opt;
    }

    protected getSaveEntity(): TItem {

        var entity: TItem = new Object() as any;

        if (this.propertyGrid != null) {
            this.propertyGrid.save(entity);
        }

        if (this.isEditMode()) {
            var idField = this.getIdProperty();
            if (idField != null && entity[idField] == null) {
                entity[idField] = this.get_entityId();
            }
        }

        return entity;
    }

    protected getSaveRequest(): SaveRequest<TItem> {

        var entity = this.getSaveEntity();
        var req: SaveRequest<TItem> = {};
        req.Entity = entity;

        if (this.isEditMode()) {
            var idField = this.getIdProperty();
            if (idField != null) {
                req.EntityId = this.get_entityId();
            }
        }

        if (this.localizationPendingValue != null) {
            req.Localizations = this.getPendingLocalizations();
        }

        return req;
    }

    protected onSaveSuccess(response: SaveResponse): void {
    }

    protected save_submitHandler(callback: (response: SaveResponse) => void): void {
        var options = this.getSaveOptions(callback);
        this.saveHandler(options, callback);
    }

    protected save(callback?: (response: SaveResponse) => void): void | boolean {
        return ValidationHelper.submit(this.byId('Form'),
            () => this.validateBeforeSave(),
            () => this.save_submitHandler(callback));
    }

    protected saveHandler(options: ServiceOptions<SaveResponse>,
        callback: (response: SaveResponse) => void): void {
        serviceCall(options);
    }

    protected createToolbar(buttons: ToolButton[]) {

        super.createToolbar(buttons);

        if (!this.toolbar)
            return;

        this.saveAndCloseButton = this.toolbar.findButton('save-and-close-button').hide();
        this.saveAndCloseButton.prev('.separator').addClass('dialog-button-separator');
        this.applyChangesButton = this.toolbar.findButton('apply-changes-button').hide();
        this.deleteButton = this.toolbar.findButton('delete-button').hide();
        this.undeleteButton = this.toolbar.findButton('undo-delete-button').hide();
        this.cloneButton = this.toolbar.findButton('clone-button').hide();
        this.localizationButton = this.toolbar.findButton('localization-button').hide();
    }

    protected showSaveSuccessMessage(response: SaveResponse): void {
        notifySuccess(localText('Controls.EntityDialog.SaveSuccessMessage'), '', null);
    }

    protected getButtons(): ToolButton[] {

        var list = super.getButtons();

        list.push({
            title: localText('Controls.EntityDialog.SaveButton'),
            cssClass: 'save-and-close-button dialog-button',
            icon: 'fa-check-circle text-purple',
            hotkey: 'alt+s',
            separator: true,
            onClick: () => {
                this.save(response => {
                    this.dialogClose();
                });
            },
            visible: () => !!this.isDialogOpen && !this.isDeleted() && !this.isViewMode(),
            disabled: () => !this.hasSavePermission() || this.readOnly,
        });

        list.push({
            title: '',
            hint: localText('Controls.EntityDialog.ApplyChangesButton'),
            cssClass: 'apply-changes-button dialog-button',
            hotkey: 'alt+a',
            icon: 'fa-clipboard-check text-purple',
            onClick: () => {
                this.save(response1 => {

                    if (this.isEditMode()) {
                        var id1 = response1.EntityId;
                        if (id1 == null) {
                            id1 = this.get_entityId();
                        }
                        this.loadById(id1);
                    }
                    else {
                        this.loadById(response1.EntityId);
                    }

                    this.showSaveSuccessMessage(response1);
                });
            },
            visible: () => !!this.isDialogOpen && !this.isDeleted() && !this.isViewMode(),
            disabled: () => !this.hasSavePermission() || this.readOnly
        });

        list.push({
            title: localText('Controls.EntityDialog.DeleteButton'),
            cssClass: 'delete-button dialog-button',
            icon: 'fa-trash-o text-red',
            hotkey: 'alt+x',
            onClick: () => {
                confirmDialog(localText('Controls.EntityDialog.DeleteConfirmation'), () => {
                    this.doDelete(() => this.dialogClose());
                });
            },
            visible: () => !!this.isDialogOpen && this.isEditMode() && !this.isDeleted() && !this.isViewMode(),
            disabled: () => !this.hasDeletePermission() || this.readOnly
        });

        list.push({
            title: localText('Controls.EntityDialog.UndeleteButton'),
            cssClass: 'undo-delete-button dialog-button',
            onClick: () => {
                if (this.isDeleted()) {
                    confirmDialog(localText('Controls.EntityDialog.UndeleteConfirmation'), () => {
                        this.undelete(() => this.loadById(this.get_entityId()));
                    });
                }
            },
            visible: () => !!this.isDialogOpen && this.isEditMode() && this.isDeleted() && !this.isViewMode(),
            disabled: () => !this.hasDeletePermission() || this.readOnly
        });

        list.push({
            title: localText('Controls.EntityDialog.LocalizationButton'),
            cssClass: 'localization-button dialog-button',
            onClick: () => this.localizationButtonClick()
        });

        list.push({
            title: localText('Controls.EntityDialog.CloneButton'),
            cssClass: 'clone-button dialog-button',
            icon: 'fa-clone',
            onClick: () => {

                if (!this.isEditMode()) {
                    return;
                }

                var cloneEntity = this.getCloningEntity();

                Widget.create({
                    type: getInstanceType(this),
                    init: w => SubDialogHelper.bubbleDataChange(
                        SubDialogHelper.cascade(w, this.element), this, true)
                        .loadEntityAndOpenDialog(cloneEntity, null)
                });
            },
            visible: () => false,
            disabled: () => !this.hasInsertPermission() || this.readOnly
        });

        return list;
    }

    protected getCloningEntity(): TItem {
        return EntityDialog.prototype["getCloningEntity"].apply(this, arguments);
    }

    override updateInterface(): void {

        EditorUtils.setContainerReadOnly(this.dialogPane, false);

        var isOpen = !!this.isDialogOpen;
        var isLocalizationMode = this.isLocalizationMode();
        var hasSavePermission = this.hasSavePermission();
        var viewMode = this.isViewMode();
        var readOnly = this.readOnly;

        this.toolbar?.updateInterface();

        if (this.tabs != null) {
            TabsExtensions.setDisabled(this.tabs, 'Log', !isOpen || this.isNewOrDeleted());
        }

        if (this.propertyGrid != null) {
            this.propertyGrid.element.toggle(isOpen && !isLocalizationMode);
        }

        if (this.localizationGrid != null) {
            this.localizationGrid.element.toggle(isOpen && isLocalizationMode);
        }

        if (this.localizationButton != null) {
            this.localizationButton.toggle(this.localizationGrid != null);
            this.localizationButton.find('.button-inner')
                .text((this.isLocalizationMode() ?
                    localText('Controls.EntityDialog.LocalizationBack') :
                    localText('Controls.EntityDialog.LocalizationButton')));
        }

        if (isLocalizationMode && isOpen) {

            if (this.toolbar != null)
                this.toolbar.findButton('tool-button')
                    .not('.localization-hidden')
                    .addClass('.localization-hidden').hide();

            this.localizationButton && this.localizationButton.show();

            return;
        }

        this.toolbar.findButton('localization-hidden')
            .removeClass('localization-hidden').show();

        if (!hasSavePermission || viewMode || readOnly)
            EditorUtils.setContainerReadOnly(this.byId("Form"), true);
    }

    protected getUndeleteOptions(callback?: (response: UndeleteResponse) => void): ServiceOptions<UndeleteResponse> {
        return EntityDialog.prototype["getUndeleteOptions"].apply(this, arguments);
    }

    protected undeleteHandler(options: ServiceOptions<UndeleteResponse>, callback: (response: UndeleteResponse) => void): void {
        return EntityDialog.prototype["undeleteHandler"].apply(this, arguments);
    }

    protected undelete(callback?: (response: UndeleteResponse) => void): void {
        return EntityDialog.prototype["undelete"].apply(this, arguments);
    }

    protected getInsertPermission(): string {
        return EntityDialog.prototype["getInsertPermission"].apply(this, arguments);
    }

    protected getUpdatePermission(): string {
        return EntityDialog.prototype["getUpdatePermission"].apply(this, arguments);
    }

    protected getDeletePermission(): string {
        return EntityDialog.prototype["getDeletePermission"].apply(this, arguments);
    }

    protected hasDeletePermission() {
        return EntityDialog.prototype["hasDeletePermission"].apply(this, arguments);
    }

    protected hasInsertPermission() {
        return EntityDialog.prototype["hasInsertPermission"].apply(this, arguments);
    }

    protected hasUpdatePermission() {
        return EntityDialog.prototype["hasUpdatePermission"].apply(this, arguments);
    }

    protected hasSavePermission(): boolean {
        return EntityDialog.prototype["hasSavePermission"].apply(this, arguments);
    }

    protected editClicked: boolean;

    protected isViewMode() {
        return EntityDialog.prototype["isViewMode"].apply(this, arguments);
    }

    protected useViewMode() {
        return EntityDialog.prototype["useViewMode"].apply(this, arguments);
    }
}